module.exports = __webpack_public_path__ + "ly.svg?41489295bb65a7891cc8a0c030689412";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ly.svg
// module id = 1225
// module chunks = 0